import React from "react";
import { cn } from "../lib/utils";

const logos = {
  ditnarkoba: {
    src: "/img/logo2.png",
    alt: "Logo Ditresnarkoba",
  },
  polda: {
    src: "/img/images/img_logo_polda.png",
    alt: "Logo Polda Jawa Tengah",
  },
  polri: {
    src: "/img/images/img_logo_polri.png",
    alt: "Logo Kepolisian Negara Republik Indonesia",
  },
};

export default function AgencyMark({
  className,
  logoClassName,
  type = "ditnarkoba",
  alt,
}) {
  const logo = logos[type] || logos.ditnarkoba;

  return (
    <div className={cn("flex h-14 w-14 items-center justify-center", className)}>
      <img
        src={logo.src}
        alt={alt || logo.alt}
        className={cn("h-full w-full object-contain", logoClassName)}
      />
    </div>
  );
}
